<template>
  <div class="index">
    <van-nav-bar
        title="业务指南"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
    />

    <div class="van-doc-demo-block__card">
      <van-panel title="业务指南" desc="江山市江城管道燃气有限公司" >
        <div class="doc_title">
          1、直接装表：申请人可携带身份证或其他有效证件至网点前台填写踏勘申请和天然气安全使用告知书，填写申请单后可网点前台预约或电话预约，老旧小区3个工作日内完成装表，新建小区5个工作日内完成装表。
          <br><br>
          2、管道改装：未在燃气公司开户的使用热水器或地暖锅炉用户，申请人可携带身份证或其他有效证件至网点前台填写踏勘申请和天然气安全使用告知书并预约改装燃气管，已开户的可电话预约管道改装。老旧小区3个工作日内完成踏勘，新建小区5个工作日内完成踏勘，缴费后改装。
          <br><br>
          3、点火通气：申请人需至网点前台填写供气合同，已签过供气合同的可电话预约点火，老旧小区3个工作日内完成点火作业，新建小区5个工作日内完成点火作业。
          <br><br>
          4、维修服务：请直接拨打服务热线400 826 5999转拨分机号2#或0570-4517517。
          <br><br>
          5、电子发票：用户充值后，如需开具电子发票的，可致电服务热线400 826 5999转拨分机号2#或0570-4517517。
          <br><br>
          6、后付费抄表：每年的1月、4月、7月、10月为后付费用户抄表月，抄表时间预计为：10号-20号<br>
          年阶梯计算方式：每年的4月1日起至来年3月31日止<br>
          阶梯量及阶梯气费及：<br>
          0-360方 2.99元/m³<br>
          360-540 3.59元/m³<br>
          540以上 4.49元/m³<br><br>

          7、自闭阀须知：<br>

        </div>

        <van-image fit="cover" :src="require('./../assets/img/zbfxz.jpg')" />

      </van-panel>
    </div>



  </div>
</template>
<script>
export default {
  name: 'page_bind',
  data() {
    return {

    };
  },
  methods: {
    onClickLeft(){
      this.$router.go(-1);
    }

  },
  mounted () {

  }
}
</script>
<style>
.index{
  height: 100vh;
  background-color: #f5f5f5;
}
.doc-demo-block__card {
  margin: 16px 12px 0px;
  overflow: hidden;
  border-radius: 8px;
}
.doc_title {
  margin: 0;
  padding: 22px 16px 0px 16px;
  color: rgba(69, 90, 100, 0.6);
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
}
</style>